import React from 'react';
import styled from 'styled-components';

const Wrap = styled.div`
  display: flex;
  gap: 2px;
  margin-top: 8px;
`;

interface ITextCardWrapProps {
  item: any;
}

const TextCardWrap: React.FC<ITextCardWrapProps> = ({ item }: ITextCardWrapProps) => {
  return <Wrap>{item}</Wrap>;
};

export default TextCardWrap;
